import { render, staticRenderFns } from "./TwoPup.vue?vue&type=template&id=16e6f1ca&scoped=true"
import script from "./TwoPup.vue?vue&type=script&lang=js"
export * from "./TwoPup.vue?vue&type=script&lang=js"
import style0 from "./TwoPup.vue?vue&type=style&index=0&id=16e6f1ca&prod&lang=scss&scoped=true"
import style1 from "./TwoPup.vue?vue&type=style&index=1&id=16e6f1ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e6f1ca",
  null
  
)

export default component.exports